import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_authenticated/sites")({
  component: SitesLayout,
});

function SitesLayout() {
  return <Outlet />;
}
